import React from "react";
import { ShieldCheckIcon, ClipboardDocumentCheckIcon, ExclamationTriangleIcon, ChartBarIcon } from "@heroicons/react/24/outline";

export default function StatCards({ stats, activeCard, onSelect }) {
  const cards = [
    { id: "enabled", label: "Enabled Frameworks", value: stats.enabledCount, icon: ShieldCheckIcon, color: "text-indigo-600" },
    { id: "total", label: "Total Frameworks", value: stats.totalCount, icon: ShieldCheckIcon, color: "text-gray-700" },
    { id: "completed", label: "Completed Controls", value: stats.completed, icon: ClipboardDocumentCheckIcon, color: "text-green-600" },
    { id: "pending", label: "Pending Controls", value: stats.pending, icon: ExclamationTriangleIcon, color: "text-red-600" },
    { id: "score", label: "Compliance Score", value: `${stats.score}%`, icon: ChartBarIcon, color: "text-purple-600" },
  ];

  return (
    <div className="grid grid-cols-2 gap-5 h-full">
      {cards.map((card) => {
        const Icon = card.icon;
        const active = activeCard === card.id;
        return (
          <button
            key={card.id}
            type="button"
            aria-pressed={active}
            onClick={() => onSelect(card.id)}
            className={`bg-white rounded-xl shadow-sm border p-8 text-left transition-shadow hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300 ${
              active ? "border-indigo-400 ring-1 ring-indigo-200" : "border-gray-200"
            }`}
          >
            <div className="flex items-center">
              <Icon className={`w-10 h-10 ${card.color}`} />
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">{card.label}</p>
                <p className="text-3xl font-bold text-gray-900">{card.value}</p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
